<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.2、{{ fuelType == 1 ? '电机转速' : '发动机转速' }}</h3>
        <!-- ECharts 柱状图容器 -->
        <div ref="speedChart" class="chart-container" style="height: 260px;margin-top: 15px;"></div>
        <div class="table-caption">图表2</div>
        <!-- 横向多列表格（完全匹配截图） -->
        <el-table :data="tableData" :cell-class-name="cellStyle">
            <!-- 表头合并：转速列 -->
            <el-table-column label="转速(r/min)" align="center">
                <template slot-scope="scope">
                    {{ scope.row.speedLabel }}
                </template>
            </el-table-column>
            <!-- 时间列 -->
            <el-table-column label="时间(小时)" prop="time" align="center" />
            <!-- 百分比列 -->
            <el-table-column label="百分比(%)" prop="percent" align="center" />
        </el-table>
        <div class="table-caption">数据表2</div>
        <!-- 说明文本 -->
        <!-- <div class="note">
            <p>说明：</p>
            <p>采集段内的最高转速为2310.5r/min 。</p>
        </div> -->
    </div>
</template>

<script>

export default {
    name: "vehicle_engine_speed_data",
    props: {
        engineRevChart: {
            type: Array,
            default: () => ([])
        },
        fuelType: {
            type: Number,
            default: 1
        }
    },
    watch: {
        engineRevChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.updateChart();
                }
            },
            deep: true
        }
    },

    data() {
        return {

            tableData: [

            ],
            myChart: undefined,

        };
    },
    mounted() {
        this.initSpeedChart();
    },
    methods: {
        updateChart() {
            var data = []
            var totalTime = 0;
            var xAxisData = [];
            var seriesData = [];
            this.engineRevChart.forEach(item => {
                // item.speedLabel = item.speedLabel.replace('r/min', '');
                data.push({
                    speedLabel: this.fuelType == 1 ? item.StandardName : item.EngineRevName,
                    time: item.WorkHour,
                    percent: item.PointPerCent
                })
                totalTime += parseFloat(item.WorkHour);
                xAxisData.push(this.fuelType == 1 ? item.StandardName : item.EngineRevName);
                seriesData.push(parseFloat(item.PointPerCent));
            })
            data.push({
                speedLabel: '累计',
                time: totalTime.toFixed(2),
                percent: '100'
            });

            this.tableData = data;

            const option = {
                xAxis: {
                    data: xAxisData,
                },
                series: [{
                    data: seriesData,
                }
                ]
            };

            this.myChart.setOption(option);
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.isGreen) {
                return 'cell-header-success';
            } else {
                if (columnIndex === 0) {
                    return 'cell-header';
                }
            }

        },
        // 合并单元格方法
        initSpeedChart() {
            const chartDom = this.$refs.speedChart;
            this.myChart = echarts.init(chartDom);

            // 图表配置
            const option = {
                title: {
                    text: '',
                    left: 'center',

                },
                backgroundColor: '#E2F0FF',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                xAxis: {
                    name: this.fuelType == 1 ? '电机转速(r/min)' : '发动机转速(r/min)',
                    nameLocation: 'center',
                    nameGap: 40,
                    type: 'category',
                    data: [],
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '百分比(%)'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',

                        label: {
                            show: true,
                            position: 'top'
                        },
                        itemStyle: {
                            color: '#409EFF'
                            // color: function (params) {
                            //     // 700区间用深蓝色，其他用绿色/蓝色
                            //     return params.dataIndex === 2 ? '#3E79B9' :
                            //         params.dataIndex === 3 ? '#6AA5D7' :
                            //             params.dataIndex === 12 ? '#6AA5D7' : '#5BC78E';
                            // }

                        }
                    }
                ]
            };

            this.myChart.setOption(option);

            // 监听窗口 resize，自适应图表
            window.addEventListener('resize', () => {
                this.myChart.resize();
            });
        }
    }
};
</script>
<style scoped></style>